module.exports = __webpack_public_path__ + "img/20.ce697137.jpg";